import { onMounted, ref, type Ref } from 'vue';
import { useSharedApi } from '../../../api/shared.api';
import type { HtmlContent } from '../models/html-content.model';

// TODO: handle language change
export const useLoadHtmlContent = (key: string) => {
  const htmlContentApi = useSharedApi().htmlContent;

  const htmlContent: Ref<HtmlContent | undefined> = ref(undefined);

  onMounted(() => {
    loadHtmlContent();
  });

  const loadHtmlContent = async () => {
    const response = await htmlContentApi.loadContent(key, 'hu').catch(() => {
      return { data: { html: '' } };
    });

    htmlContent.value = response.data;
  };

  return {
    htmlContent
  };
};
